import {usePlant} from './usePlant'

import {DEFAULT_TIME_ZONE} from '@predict/UtilsLib/dateTime/constants'

export const usePlantTimeZone: () => string = () => {
  const plant = usePlant()
  return plant?.timeZone ?? DEFAULT_TIME_ZONE
}
